import { useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { Grid, Row, Col, Loader } from 'rsuite'
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Worker } from '@react-pdf-viewer/core';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


const Verify = () => {
    const { id } = useParams();

    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const uri = `https://admin.bcuni.eu/api/student/document/${id.replace("98711", "")}`;

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    // useEffect(() => {
    //     const fetchPdf = async () => {
    //         try {
    //             // 1. API'ye isteği biz atıyoruz (Backend adresiniz)
    //             // Not: Eğer token gerekiyorsa headers içine ekleyebilirsiniz.
    //             const response = await fetch(`https://admin.bcuni.eu/api/student/document/${id.replace("98711", "")}`, {
    //                 method: 'GET',
    //                 headers: {
    //                     // 'Authorization': `Bearer ${token}`, // Gerekirse
    //                 }
    //             });

    //             if (!response.ok) throw new Error("Dosya indirilemedi");

    //             // 2. Gelen veriyi "BLOB" (Binary Large Object) formatına çeviriyoruz
    //             const blob = await response.blob();

    //             // 3. Tarayıcı hafızasında bu blob için geçici bir URL oluşturuyoruz
    //             // Bu url şuna benzer: blob:http://localhost:3000/123-abc-456...
    //             const objectUrl = URL.createObjectURL(blob);

    //             setPdfUrl(objectUrl);
    //             setLoading(false);

    //         } catch (err) {
    //             console.error("PDF Hatası:", err);
    //             setError(true);
    //             setLoading(false);
    //         }
    //     };

    //     fetchPdf();

    //     // Temizlik: Component kapanırken hafızadaki url'i siliyoruz (Memory Leak önlemek için)
    //     return () => {
    //         if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    //     };
    // }, [id]);

    // if (loading)
    //     return <div style={{ textAlign: 'center', marginTop: 50 }}><Loader size="lg" content="Belge yükleniyor..." /></div>;
    // if (error)
    //     return <div style={{ textAlign: 'center', marginTop: 50, color: 'red' }}>Belge yüklenirken bir hata oluştu.</div>;

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            <div style={{ padding: 20, borderBottom: "1px solid #ddd", background: "#fff" }}>
                <h3>Belge Doğrulama</h3>
            </div>
            {window.innerWidth > 500 ? <Grid>
                <Row className="show-grid">
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <div style={{ height: '100vh' }}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                <Viewer
                                    fileUrl={uri}
                                    defaultScale={1}
                                    plugins={[
                                        defaultLayoutPluginInstance
                                    ]}
                                />
                            </Worker>
                            {/* <iframe
                                src={pdfUrl}
                                width="100%"
                                height="100%"
                                style={{ border: "none", flex: 1 }}
                                title="Öğrenci Belgesi"
                            /> */}
                            {/* <PDFViewer config={{
                                src: pdfUrl,
                                theme: { preference: 'light' }

                            }}
                                style={{ height: '100vh', overflow: 'hidden' }}
                            /> */}
                        </div>
                    </Col>
                </Row>
            </Grid>
                : <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={uri}
                        defaultScale={0.7}
                        plugins={[
                            defaultLayoutPluginInstance
                        ]}
                    />
                </Worker>}

            {/* 4. Oluşturduğumuz blob URL'i kaynağa veriyoruz */}

        </div>
    );

    // return (
    //     <div style={styles.container}>

    //         {/* Üst Bilgi Alanı */}
    //         <div style={styles.header}>
    //             <h2>Belge Doğrulama Sistemi</h2>
    //             <p>Görüntülenen Belge ID: <strong>{id}</strong></p>
    //         </div>

    //         {/* PDF Görüntüleyici */}
    //         <Grid>
    //             <Row className="show-grid">
    //                 <Col xs={24} sm={24} md={16} mdOffset={4}>
    //                     <div style={{ height: '100vh' }}>
    //                         <PDFViewer config={{
    //                             src: pdfUrl,
    //                             theme: { preference: 'light' }
    //                         }} />
    //                     </div>
    //                 </Col>
    //             </Row>
    //         </Grid>




    //     </div >
    // );
};

// Basit CSS Stilleri (İsterseniz CSS dosyasına taşıyın)
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // Tüm ekranı kapla
        backgroundColor: '#f5f5f5',
    },
    header: {
        padding: '20px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #ddd',
        textAlign: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 10
    },
    pdfWrapper: {
        flex: 1, // Kalan tüm alanı kapla
        padding: '20px',
        display: 'flex',
        justifyContent: 'center'
    },
    fallback: {
        textAlign: 'center',
        marginTop: '50px',
        color: '#666'
    },
    button: {
        display: 'inline-block',
        marginTop: '10px',
        padding: '10px 20px',
        backgroundColor: '#007bff',
        color: '#fff',
        textDecoration: 'none',
        borderRadius: '5px'
    }
};

export default Verify